import type { VoucherValidityMode } from '@/gql/graphql';

/** A night as the rule form works with it (picker row, selected summary, stage list). */
export interface RuleNight {
  id: string;
  title: string;
  startsAt: string;
  scope: { id: string; name: string };
  stages: { id: string; name: string; isActive: boolean }[];
}

export const VALIDITY_MODES: VoucherValidityMode[] = [
  'AFTER_CLAIM',
  'NIGHT',
  'AFTER_NIGHT',
];

/** Modes that need a `validUntil` day; NIGHT ignores it (the form hides the field and sends null). */
export function validityModeNeedsEndDate(mode: VoucherValidityMode | ''): boolean {
  return mode === 'AFTER_CLAIM' || mode === 'AFTER_NIGHT';
}
